// extracted by mini-css-extract-plugin
export default {"root":"Markdown_root__oIhik"};